import React, { ReactElement, useEffect } from "react";
import { jsx, css, SerializedStyles } from "@emotion/react";
import { useTrelloPowerUpContext } from "../../../../external/trello-pu__core/trello-iframe/context";

type TProps = {
  confirmationContent: ReactElement | string;
  confirmationButtonText: string;
  confirmationButtonTrelloClass: "mod-danger" | "mod-primary";
  confirmationContentCss?: SerializedStyles;
  onConfirmationButtonClick(): void;
};

function PopoverConfirmationContent(props: TProps) {
  const { trelloIFrame } = useTrelloPowerUpContext();

  useEffect(() => {
    trelloIFrame.sizeTo("#attachment-section-root");
  });

  return (
    <div css={styles.confirmationContainer} id="popup-confirmation">
      <span css={[styles.confirmationText, props.confirmationContentCss]}>
        {props.confirmationContent}
      </span>
      <button
        className={props.confirmationButtonTrelloClass}
        css={styles.button}
        onClick={props.onConfirmationButtonClick}
      >
        {props.confirmationButtonText}
      </button>
    </div>
  );
}

export default PopoverConfirmationContent;

const styles = {
  button: css`
    margin: 0 8px;
  `,
  confirmationContainer: css`
    display: flex;
    flex-direction: column;
  `,
  confirmationText: css`
    padding: 8px;
    margin-bottom: 8px;
  `,
};
